import { render } from "./Nutrition.vue?vue&type=template&id=5a126bef"
import script from "./Nutrition.vue?vue&type=script&lang=js"
export * from "./Nutrition.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Desktop\\all-in-one\\all-in-one-fitness\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__